import { render, staticRenderFns } from "./modal-permissions.component.html?vue&type=template&id=0fd76f0b&scoped=true&external"
import script from "./modal-permissions.component.ts?vue&type=script&lang=ts&external"
export * from "./modal-permissions.component.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-permissions.component.scss?vue&type=style&index=0&id=0fd76f0b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd76f0b",
  null
  
)

export default component.exports